module.exports = __webpack_public_path__ + "img/clouds.4e02f2ec.jpg";